import { fileCodeBackendTemplateController } from "..";
import { FindFilter, ListFilter } from "../../model/model/filter/Filter";
import { Paging } from "../../model/model/filter/Paging";
import { BackendTemplate } from "../../model/model/gencode/BackendTemplate";
import { BaseController } from "../fake/BaseController";

export class BackendTemplateController extends BaseController<BackendTemplate> {
	async list(params: ListFilter<BackendTemplate>): Promise<Paging<BackendTemplate>> {
        const templates =await  super.list(params);
        const files =await fileCodeBackendTemplateController.find();
        templates.rows?.map(item=>{
            item.fileTemplates = files.filter(file=>file.templateId == item.id);
            return item;
        })
        return templates;
    }
    async find(params?: FindFilter<BackendTemplate>): Promise<BackendTemplate[]> {
        const templates =await  super.find(params);
        const files =await fileCodeBackendTemplateController.find();
        templates.map(item=>{
            item.fileTemplates = files.filter(file=>file.templateId == item.id);
            return item;
        })
        return templates;
    }
}
